import axios from 'axios';
import store from '../store';

// axios.interceptors.response.use(
//   function(response) { return response; },
//   function(error) {
//       if (error.response) {
//         console.log(error.response);
//         store.commit('showNotification', { text: error.response.data.error, status: 'error' });
//         return Promise.reject(error);
//       }
//   });

// const baseUrl = 'http://192.168.1.8:3000';
const baseUrl = process.env.VUE_APP_ROOT_API;

const state = {
  projetosVinculos: [],
};

const getters = {
  projetosVinculos: state => state.projetosVinculos,
}

const actions = {
  async fetchProjetosVinculos({ commit }, { idProjeto }) {
    const response = await axios.get(`${baseUrl}/projetosvinculos/${idProjeto}`);
    if (response.data.length) {
      commit('setProjetosVinculos', response.data);
    } else {
      commit('setProjetosVinculos', []);
    }
  },
  async addProjetoVinculo({ commit }, itemProjeto) {
    const response = await axios.post(`${baseUrl}/projetosvinculos`, itemProjeto);
    commit('newProjetoVinculo', response.data);
  },
  async deleteProjetoVinculo({ commit }, projetoVinculo) {
    await axios.delete(`${baseUrl}/projetosvinculos/${projetoVinculo.IdProjeto}/${projetoVinculo.IdProjetoVinculo}?projeto=${projetoVinculo.Projeto}`);
    commit('removeProjetoVinculo', projetoVinculo.IdProjetoVinculo);
  },
}

const mutations = {
  setProjetosVinculos: (state, vinculos) => state.projetosVinculos = vinculos,
  newProjetoVinculo: (state, vinculo) => state.projetosVinculos.push(vinculo),
  removeProjetoVinculo: (state, id) => state.projetosVinculos = state.projetosVinculos.filter(av => av.IdProjetoVinculo !== id)
}

export default {
  state,
  getters,
  actions,
  mutations
}